import { physicianUpsertModalRouteStore } from '../components/physician-upsert-modal/domain/store';

export default (showing = true) => {
  physicianUpsertModalRouteStore.setValue('showingDeleteConfirmationModal', showing);
};
